import ApartmentFreeTooltip from './ApartmentFreeTooltip';

export default ApartmentFreeTooltip;
